
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://xdyjxgwfjcoysmopmamd.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhkeWp4Z3dmamNveXNtb3BtYW1kIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzIxNjk3MzksImV4cCI6MjA4Nzc0NTczOX0.POidJbUwhfbGgESfnXg3MjSL6akwfJhOK6ZsUPU1ayc';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
